//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import layer from './layer.vue'
import { FactoryUtils } from "../../utils/FactoryUtils"
import BScroll from 'better-scroll'
    export default {
        name:'serveContentToast',
        data(){
            return {
              showFlag:false,
              title:'',
              product:[],
              planBScroll:null,
            }
        },
        components: {
          layer
        },
        created(){
            FactoryUtils.productDetails().then(data =>{
                console.log('--',data)
                this.title=data.quersTitle
                this.product=data.moreHotList
            })
        },
        mounted(){
           
        },
        methods:{
        askClick(e){
            if(this.product[e].flag){
                this.product[e].flag=false
            }else{
                this.product[e].flag=true
            }
        },  
          showToast(){
            this.showFlag = true;
            this.$nextTick(() => {
                if (!this.planBScroll) {
                    this.planBScroll = new BScroll(this.$refs.planBox, {
                        click: true,
                        scrollY: true,
                    });
                } else {
                    this.planBScroll.refresh()
                }
            })
          },
          close(){
            this.$refs.layerRef.removeTouch()
            this.showFlag = false;
            this.planBScroll = null;
          }
        }
    }
